import { useState } from 'react';
import { PageLayout } from '../../../../PageLayout';
import { IdentifyRPMAccountStep } from './IdentifyRPMAccountStep';
import { RPMFieldMappingStep } from './RPMFieldMappingStep';
import { PreviewProvisionalAssetsStep } from './PreviewProvisionalAssetsStep';
import { CompleteProvisionalAssetsStep } from './CompleteProvisionalAssetsStep';

const stepInfo = [
  { component: IdentifyRPMAccountStep, title: 'Step 1 of 3: Identify RPM Account IDs' },
  { component: RPMFieldMappingStep, title: 'Step 2 of 3: Review RPM Field Mapping' },
  { component: PreviewProvisionalAssetsStep, title: 'Step 3 of 3: Preview Provisional Assets' },
  { component: CompleteProvisionalAssetsStep, title: 'Success! Provisional Asset Load Complete' }
];

export const CreateProvisionalAssetTab = () => {
  const [step, setStep] = useState<number>(1);

  const currentStepInfo = stepInfo[step - 1];

  const CurrentStepComponent = currentStepInfo?.component;
  const title = currentStepInfo?.title;

  return (
    <PageLayout
      className="w-full"
      dataTestId="create-provisional-asset-page"
      dataCy="create-provisional-asset-page-card"
      pageTitle="">
      {currentStepInfo ? (
        <CurrentStepComponent
          nextStep={() => setStep(step + 1)}
          title={title}
        />
      ) : (
        <div>New Step In Progress</div>
      )}
    </PageLayout>
  );
};
